export const THEME_STORAGE_KEY = 'webford-color-scheme';
export const LIGHT_THEME = 'light';
export const DARK_THEME = 'dark';

function getDocumentRoot() {
  return typeof document === 'undefined' ? null : document.documentElement;
}

function getBrowserStorage() {
  try {
    return typeof window === 'undefined' ? null : window.localStorage;
  } catch {
    return null;
  }
}

export function normalizeTheme(value) {
  return value === DARK_THEME ? DARK_THEME : LIGHT_THEME;
}

export function isDarkTheme(theme) {
  return normalizeTheme(theme) === DARK_THEME;
}

export function getThemeToggleLabel(isDark) {
  return isDark ? '切换到浅色模式' : '切换到深色模式';
}

export function readStoredTheme(storage = getBrowserStorage()) {
  try {
    return normalizeTheme(storage?.getItem(THEME_STORAGE_KEY));
  } catch {
    return LIGHT_THEME;
  }
}

export function applyTheme(theme, root = getDocumentRoot()) {
  const normalizedTheme = normalizeTheme(theme);

  root?.classList?.toggle('dark', normalizedTheme === DARK_THEME);
  if (root?.style) root.style.colorScheme = normalizedTheme;

  return normalizedTheme;
}

export function setTheme(theme, options = {}) {
  const root = options.root === undefined ? getDocumentRoot() : options.root;
  const storage = options.storage === undefined ? getBrowserStorage() : options.storage;
  const normalizedTheme = applyTheme(theme, root);

  try {
    storage?.setItem(THEME_STORAGE_KEY, normalizedTheme);
  } catch {
    // Theme changes remain usable for the current session when storage is blocked.
  }

  return normalizedTheme;
}

export function initializeTheme(options = {}) {
  const root = options.root === undefined ? getDocumentRoot() : options.root;
  const storage = options.storage === undefined ? getBrowserStorage() : options.storage;

  return applyTheme(readStoredTheme(storage), root);
}
